module.exports = __webpack_public_path__ + "img/td_bldgsmall.b5059bc0.jpg";